import axios from 'axios';
import { ENDPOINTS } from '../api/apiConfig';

export type ActivityAction = 'view' | 'select' | 'action';
export type ActivityEntityType =
    | 'page'
    | 'report'
    | 'area'
    | 'pattern'
    | 'pattern_point'
    | 'metric'
    | 'measurement';

export interface ActivityPayload {
    action: ActivityAction;
    entityType: ActivityEntityType;
    entityId?: number | null;
    route?: string | null;
    areaId?: number | null;
    reportTemplateId?: number | null;
    patternId?: number | null;
    patternPointId?: number | null;
    metricId?: number | null;
    measurementId?: number | null;
    dateFrom?: Date | string | null;
    dateTo?: Date | string | null;
}

const toIso = (value?: Date | string | null): string | null => {
    if (!value) return null;
    if (value instanceof Date) return value.toISOString();
    return value;
};

export const trackActivity = (payload: ActivityPayload): void => {
    const body = {
        ...payload,
        dateFrom: toIso(payload.dateFrom),
        dateTo: toIso(payload.dateTo),
    };

    void axios.post(ENDPOINTS.ACTIVITY_TRACK, body, { withCredentials: true }).catch(() => {
        // Activity tracking is best-effort; ignore failures.
    });
};
